/**
 * Email validation regex pattern
 * Matches the C# backend regex exactly (EmailRegex constant)
 * 
 * Allows the following special characters:
 * ! (exclamation), # (hash), % (percent), & (ampersand), * (asterisk),
 * ' (apostrophe), - (hyphen), $ (dollar), / (slash), = (equals),
 * ? (question), ^ (caret), ` (backtick), { (brace), | (pipe), } (brace), ~ (tilde)
 * 
 * Pattern explanation:
 * - No consecutive dots (..)
 * - No dot immediately before @
 * - Local part: word chars + allowed special characters
 * - Domain: word chars, dots, hyphens
 * - TLD: 2-19 characters
 */
export const EMAIL_REGEX = /^(?!.*\.\.)(?!.*\.@)[\w._+\-!#%&*'$/=?^`{|}~]+@[\w.\-]+\.[\w]{2,19}$/

export const EMAIL_REGEX_STRING = "^(?!.*\\.\\.)(?!.*\\.@)[\\w._+\\-!#%&*'$/=?^`{|}~]+@[\\w.\\-]+\\.[\\w]{2,19}$"
